import { render, staticRenderFns } from "./addParameterSwitching.vue?vue&type=template&id=7f66aaf8&scoped=true&"
import script from "./addParameterSwitching.vue?vue&type=script&lang=js&"
export * from "./addParameterSwitching.vue?vue&type=script&lang=js&"
import style0 from "./addParameterSwitching.vue?vue&type=style&index=0&id=7f66aaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66aaf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f66aaf8')) {
      api.createRecord('7f66aaf8', component.options)
    } else {
      api.reload('7f66aaf8', component.options)
    }
    module.hot.accept("./addParameterSwitching.vue?vue&type=template&id=7f66aaf8&scoped=true&", function () {
      api.rerender('7f66aaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addParameterSwitching.vue"
export default component.exports